import moment from 'moment-timezone';

export const timeStamp = (moment().tz("Asia/Singapore").format()).replace(/T/, ' ').replace("+08:00", '');
export const dateFormatOnly = (moment().format('MMMM DD, YYYY'));